import { CommonModule, KeyValuePipe } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { AuthService } from '@auth/services/auth.service'
import { Zone } from '@events/models/zone.model'
import { EventService } from '@events/services/event.service'
import { format } from 'date-fns'
import { Subject, takeUntil } from 'rxjs'
/**
 * Displays daily visitors
 */
@Component({
  selector: 'ngx-capacity-by-daily-dates',
  templateUrl: './capacity-by-daily-dates.component.html',
  styleUrls: ['./capacity-by-daily-dates.component.scss'],
  imports: [CommonModule, KeyValuePipe]
})
export class CapacityByDailyDatesComponent implements OnInit {
  /**
   * Zone model
   */
  private _zone: Zone | string
  /**
   * Event model
   */
  @Input()
  event
  /**
   * Sets the zone model and initializes the component
   */
  @Input()
  set zone(value: any) {
    this._zone = value
    this.initialize()
  }
  /**
   * Gets the zone model
   */
  get zone(): any {
    return this._zone
  }
  /**
   * Displayed days
   */
  days
  /**
   * Event public start date
   */
  public_start_date
  /**
   * Event start date
   */
  startDate
  /**
   * Event end date
   */
  endDate
  private _destroy$ = new Subject()
  /**
   * Creates the component and injects it's dependencies
   * @param auth AuthService
   * @param eventService EventService
   */
  constructor(private auth: AuthService, private eventService: EventService) {}

  /**
   * Initializes the component
   */
  initialize() {
    if (this.event) {
      this.startDate = format(new Date(this.event.public_start_date), 'yyyy-MM-dd')
      this.endDate = format(new Date(this.event.public_end_date), 'yyyy-MM-dd')
      this.eventService
        .getDailyZOnes(this.auth.currentWorkspace.slug, this.event.slug, this.zone === '#all$' ? 'global' : this.zone.slug, this.startDate, this.endDate)
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          (data) => {
            this.days = data
          },
          (error) => {}
        )
    }
  }
  /**
   * Gets the day part of a date
   * @param date Date
   * @returns string
   */
  getDay(date: Date): string {
    return format(new Date(date), 'dd')
  }
  /**
   * Gets the month part of a date
   * @param date Date
   * @returns string
   */
  getMonth(date: Date): string {
    return format(new Date(date), 'MMM')
  }

  /**
   * On component initialization
   */
  ngOnInit() {
    this.initialize()
  }

  ngOnDestroy(): void {
    this._destroy$.next(null)
    this._destroy$.complete()
  }
}
